import {getPostData} from "../Constants/getPostData";
import {jsonToPhpHashMap} from "../Constants/jsonToPhpHashMap";

export const getRequestCodeSnippet = (language, url, body, mode, utilitiesInfo = null) => {
    let codeSnippet;

    switch (language) {
        case "cURL":
            codeSnippet = getCURLCode(url, body, mode, utilitiesInfo);
            break;
        case "python":
            codeSnippet = getPythonCode(url, body, mode, utilitiesInfo);
            break;
        case "javascript":
            codeSnippet = getJavascriptCode(url, body, mode, utilitiesInfo);
            break;
        case "ruby":
            codeSnippet = getRubyCode(url, body, mode, utilitiesInfo);
            break;
        case "php":
            codeSnippet = getPHPCode(url, body, mode, utilitiesInfo);
            break;
        default:
            codeSnippet = ""
    }

    return codeSnippet
}

const getCURLCode = (url, body, mode, utilitiesInfo) => {
    let postData = formatPostDataForCodeSnippet(body, "cURL");
    postData = postData.replace(/'/g, "'\\''");
    let postBody = "'" + postData + "'";

    // Add access key and secret key headers for create and download modes
    if ((mode === "create" || mode === "download") && utilitiesInfo && utilitiesInfo.keys && utilitiesInfo.keys.length > 0) {
        const accessKey = utilitiesInfo.keys[0].access_key;
        const secretKey = utilitiesInfo.keys[0].secret_key;
        
        return "$ curl -X POST '" + url + "' \\\n" +
               '-H "Content-Type: application/json" \\\n' +
               `-H "AccessKey: ${accessKey}" \\\n` +
               `-H "SecretKey: ${secretKey}" \\\n` +
               '-d ' + postBody
    }

    return "$ curl -X POST '" + url + "' \\\n-d " + postBody
}

const getPythonCode = (url, body, mode, utilitiesInfo) => {
    let code = "# pip install requests\n\nimport requests\n\n"

    let postBody = formatPostDataForCodeSnippet(body, "python");

    // Add access key and secret key headers for create and download modes
    if ((mode === "create" || mode === "download") && utilitiesInfo && utilitiesInfo.keys && utilitiesInfo.keys.length > 0) {
        const accessKey = utilitiesInfo.keys[0].access_key;
        const secretKey = utilitiesInfo.keys[0].secret_key;
        
        code += 'headers = {\n'
        code += '    "Content-Type": "application/json",\n'
        code += `    "AccessKey": "${accessKey}",\n`
        code += `    "SecretKey": "${secretKey}"\n`
        code += '}\n\n'
        code += 'r = requests.post("' + url + "\", json=" + postBody + ", headers=headers)\n\n"
    } else {
        code += 'r = requests.post("' + url + "\", json=" + postBody + ")\n\n"
    }
    
    code += "if r.status_code == 200:\n\t# SUCCESS \n\tresp_data = r.json()\nelse:\n\t# ERROR\n\tpass"

    return code
}

const getJavascriptCode = (url, body, mode, utilitiesInfo) => {
    let code = "fetch(";

    let postBody = formatPostDataForCodeSnippet(body, "javascript");

    code += '"' + url + '", {\n'
    code += '\tmethod: "POST",\n'
    
    // Add access key and secret key headers for create and download modes
    if ((mode === "create" || mode === "download") && utilitiesInfo && utilitiesInfo.keys && utilitiesInfo.keys.length > 0) {
        const accessKey = utilitiesInfo.keys[0].access_key;
        const secretKey = utilitiesInfo.keys[0].secret_key;
        
        code += '\theaders: {\n'
        code += '\t\t"Accept": "application/json, text/plain, */*",\n'
        code += '\t\t"Content-Type": "application/json",\n'
        code += `\t\t"AccessKey": "${accessKey}",\n`
        code += `\t\t"SecretKey": "${secretKey}"\n`
        code += '\t},\n'
    } else {
        code += '\theaders: {"Accept": "application/json, text/plain, */*"},\n'
    }
    
    code += "\tbody: JSON.stringify(" + postBody + ")\n"
    code += '}).then(res =>{\n'
    code += '\tif (res.status === 200){\n\t\t'
    code += 'res.json().then(data => {\n\t\t\t'
    code += '// SUCCESS\n\t\t\t'
    code += 'const respData = data;\n\t\t'
    code += '}).catch(err => console.log(err))'
    code += "\n\t}\n\telse{\n\t\t// ERROR\n\t}\n})"

    return code
}

const getRubyCode = (url, body, mode, utilitiesInfo) => {
    let code = "require 'net/http'\nrequire 'json'\n\n";

    code += 'url = "' + url + '"\n'
    code += 'uri = URI.parse(url)\n\n'

    let postBody = formatPostDataForCodeSnippet(body, "ruby");

    code += "http = Net::HTTP.new(uri.host, uri.port)\n"
    code += "request = Net::HTTP::Post.new(uri.request_uri)\n"
    
    // Add access key and secret key headers for create and download modes
    if ((mode === "create" || mode === "download") && utilitiesInfo && utilitiesInfo.keys && utilitiesInfo.keys.length > 0) {
        const accessKey = utilitiesInfo.keys[0].access_key;
        const secretKey = utilitiesInfo.keys[0].secret_key;
        
        code += "request['Content-Type'] = 'application/json'\n"
        code += `request['AccessKey'] = '${accessKey}'\n`
        code += `request['SecretKey'] = '${secretKey}'\n`
    }
    
    code += "request.body = (" + postBody + ").to_json\n\n"
    code += "response = http.request(request)\n"
    code += "if response.code == '200'\n"
    code += "\t# SUCCESS\n"
    code += "\tresp_data = JSON.parse(response.body)\n"
    code += 'else\n'
    code += '\t# ERROR\n'
    code += 'end'

    return code
}

const getPHPCode = (url, body, mode, utilitiesInfo) => {
    let postBody = formatPostDataForCodeSnippet(body, "php");

    let headers = 'array("Content-type: application/json")';
    
    // Add access key and secret key headers for create and download modes
    if ((mode === "create" || mode === "download") && utilitiesInfo && utilitiesInfo.keys && utilitiesInfo.keys.length > 0) {
        const accessKey = utilitiesInfo.keys[0].access_key;
        const secretKey = utilitiesInfo.keys[0].secret_key;
        
        headers = `array(
    "Content-type: application/json",
    "AccessKey: ${accessKey}",
    "SecretKey: ${secretKey}"
)`;
    }

    return "<?php\n" +
        `$url = "${url}";\n` +
        `$data = ${postBody};\n` +
        "$content = json_encode($data);\n" +
        "\n" +
        "$curl = curl_init($url);\n" +
        "curl_setopt($curl, CURLOPT_HEADER, false);\n" +
        "curl_setopt($curl, CURLOPT_RETURNTRANSFER, true);\n" +
        "curl_setopt($curl, CURLOPT_HTTPHEADER, " + headers + ");\n" +
        "curl_setopt($curl, CURLOPT_POST, true);\n" +
        "curl_setopt($curl, CURLOPT_POSTFIELDS, $content);\n" +
        "\n" +
        "$json_response = curl_exec($curl);\n" +
        "\n" +
        "$status = curl_getinfo($curl, CURLINFO_HTTP_CODE);\n" +
        "\n" +
        "if ($status == 200) {\n" +
        "    // SUCCESS\n" +
        "    $resp_data = json_decode($json_response, true);\n" +
        "} else {\n" +
        "    // ERROR\n" +
        "}\n" +
        "\n" +
        "curl_close($curl);\n" +
        "?>\n"
}

const formatPostDataForCodeSnippet = (postJSON, language) => {
    if (language === "php"){
        return jsonToPhpHashMap(postJSON)
    }

    return JSON.stringify(postJSON)
}